import router from '../../../router'

export const diagnostics = {
    state: {
        status: 'idle',
        diagnostics: [],
        summaryDiagnostics: null,
        locationsDiagnostics: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        filters: {
            active: {
                type: 'ui-checkbox-input',
                value: true,
                text: 'Tylko aktywne kasy'
            }
        },
        diagnosticsTooltips: {
            receipts: 'Liczba paragonów przesłana dzisiaj z urządzenia',
            receiptStatus:
                'Czerwona kontrolka: brak przesłania paragonów w ostatnich 24h',
            promotionUsage:
                'Liczba użyć promocji dzisiaj zarejestrowanych przez urządzenie fiskalne',
            usageState:
                'Czerwona kontrolka: brak przesłania użyć promocji w ostatnich 24h',
            connectionStatus:
                'Czerwona kontrolka: brak połączenia kasy z serwerem w ostatnich 5 minutach'
        }
    },
    mutations: {
        SET_DIAGNOSTICS_STATUS(state, payload) {
            state.status = payload
        },
        SET_DIAGNOSTICS(state, payload) {
            state.diagnostics = payload
        },
        SET_SUMMARY_DIAGNOSTICS(state, payload) {
            state.summaryDiagnostics = payload
        },
        SET_LOCATIONS_DIAGNOSTICS(state, payload) {
            state.locationsDiagnostics = payload
        },
        SET_DIAGNOSTICS_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_DIAGNOSTICS_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_DIAGNOSTICS_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_DIAGNOSTICS_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_DIAGNOSTICS_FILTER(state, payload) {
            state.filters[payload.filter].value = payload.value
        },
        RESET_DIAGNOSTICS_FILTERS(state, payload) {
            state.filters = payload
        }
    },
    actions: {
        diagnosticsFetch({ commit, state, getters }, payload) {
            commit('SET_DIAGNOSTICS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_DIAGNOSTICS_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_DIAGNOSTICS_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const userId = getters.userId

            return this.$api
                .get(`reports/diagnostics/${userId}?includes=state`, {
                    params: {
                        mode: payload.mode
                    }
                })
                .then(res => {
                    if (payload.mode === 'locations') {
                        commit('SET_LOCATIONS_DIAGNOSTICS', res.data.data)
                    } else if (payload.mode === 'summary') {
                        commit('SET_SUMMARY_DIAGNOSTICS', res.data.data)
                    } else {
                        commit('SET_DIAGNOSTICS', res.data.data.diagnostics)
                    }
                    commit('SET_DIAGNOSTICS_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_DIAGNOSTICS_STATUS', 'idle')
                    }
                })
        }
    },
    getters: {
        getDiagnostics: state => {
            return state.diagnostics
        },
        getActiveDiagnostics: state => {
            return state.diagnostics.filter(
                item =>
                    item.state.code === 'ACTIVE' ||
                    item.state.code === 'DURING_RESIGNATION'
            )
        },
        getDiagnosticStatuses: state => {
            if (!state.diagnostics) {
                return []
            }
            return state.diagnostics.map(el => {
                return {
                    rad_id: el.rad_id,
                    heartbeat_status: el.heartbeat_status,
                    receipt_status: el.receipt_status,
                    usage_status: el.usage_status
                }
            })
        },
        getSummaryDiagnostics: state => {
            return state.summaryDiagnostics
        },
        getLocationsDiagnostics: state => state.locationsDiagnostics,
        getDiagnosticsStatus: state => {
            return state.status
        },
        getDiagnosticsPaging: state => {
            return state.pagination
        },
        getDiagnosticsFilters: state => state.filters,
        getDiagnosticsTooltips: state => state.diagnosticsTooltips,
        someDiagnosticIsInvalid: (state, getters) => {
            return getters.getActiveDiagnostics.some(
                el => el.heartbeat_status === 'invalid'
            )
        },
        isMerchantDiagnosticInvalid: (state, getters) => locationId => {
            return getters.getActiveDiagnostics.find(el => {
                return (
                    el.location_id === locationId &&
                    (el.heartbeat_status === 'invalid' ||
                        el.receipt_status === 'invalid' ||
                        el.usage_status === 'invalid')
                )
            })
        }
    }
}
